import { AppEnv, EnvProps } from './index';
import { npdEnvDefaults } from './env-defaults';
import { prodMigratedLinks } from './react-migration';

const env: EnvProps = {
  ...npdEnvDefaults,
  appEnv: AppEnv.BF,
  ebisCoreServiceUrl: 'https://ebisbf.mlb.com/ebis2-core-services',
  ebisGlobalServiceUrl: 'https://ebisbf.mlb.com/ebis2-global-services',
  ebisClubServiceUrl: 'https://ebisbf.mlb.com/ebis2-club-services',
  ebisAdvSearchServiceUrl: 'https://ebisbf.mlb.com/ebis2-advsearch-services',
  ebisReportServiceUrl: 'https://ebisbf.mlb.com/ebis2-reports-services',
  eventBusUrl: 'https://ebisbf.mlb.com/eventbus',
  cepServiceUrl: 'https://ebis2-cep-api-stg.mlbinfra.com/ebis2-cep-services',
  reactMigration: {
    migratedLinks: prodMigratedLinks,
  },
};

window.MLBBest = { env };
